.number {
  font-weight: var(--fontWeightRegular);
  font-size: 19px;
  color: var(--paletteBlack0);
}

.button {
  border: none;
  opacity: 0.6;
  padding: var(--spacingMd);
  padding-top: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  &.active {
    opacity: 1;
    border-bottom: 2px solid var(--palettePrimary0);
  }
}

.title {
  font-weight: var(--fontWeightSemibold);
  color: var(--paletteBlue0);

  @media (max-width: 1600px) {
    font-size: var(--fontSizeLabel);
  }
}
